import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../../common/form';

import { IMAGE_LIMITS } from '../../../../utils/constants';

import * as utils from '../../../../utils/utilities';

class PECScanPlanForm extends Form {
	state = {
		data: { plans: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		initialImages: PropTypes.array,
		onProceed: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialImages && this.props.initialImages.length > 0) {
			this.setState({ data: { plans: this.props.initialImages }});
		}
	}

	schema = {
		plans: Joi.array().min(1).max(IMAGE_LIMITS.ISO_IMAGE).required().label('Scan Plan(s)'),
	};

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.plans);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: IMAGE_LIMITS.ISO_IMAGE,
					multiple: IMAGE_LIMITS.ISO_IMAGE > 1,
					name: 'plans',
					accept: 'image/*,application/pdf',
					label: 'Scan Plan(s)',
					sublabel: 'Upload Scan Plan(s)',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default PECScanPlanForm;
